var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/maps/place_24px"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u21B3Color",
    d: "M13 24a53.6 53.6 0 0 1-4.5-5.21C6.447 16.068 4 12.169 4 9.05a7.6 7.6 0 0 1 2.634-5.694A9.5 9.5 0 0 1 13 1a9.5 9.5 0 0 1 6.366 2.356A7.6 7.6 0 0 1 22 9.05c0 3.119-2.447 7.017-4.5 9.739A53.6 53.6 0 0 1 13 24Zm0-17.825A3.063 3.063 0 0 0 9.786 9.05 3.063 3.063 0 0 0 13 11.926a3.063 3.063 0 0 0 3.214-2.876A3.063 3.063 0 0 0 13 6.175Z",
    fill: "rgba(0,0,0,0.62)"
  })))));
};
export default SvgPin;